import React, {useState, useEffect, useMemo} from 'react'
import PropTypes from 'prop-types';

import { Box, Grid, Paper, Typography, Button, IconButton, Card, Alert } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import {useHistory, useParams} from 'react-router-dom';

import { HOSPITAL_LAB_REQUEST, HOSPITAL_LAB, HOSPITAL_PATIENT_SUBMISSION, HOSPITAL_LAB_RESULT, HOSPITAL_IMAGING_REQUEST, HOSPITAL_IMAGES, HOSPITAL_SHOES, HOSPITAL_SHOES_REQUEST, HOSPITAL_SURGERY_REQUEST, HOSPITAL_SURGERY_CREATE_APPOINTMENT_FROM_REQUEST, HOSPITAL_SURGERY_APPOINTMENT, HOSPITAL_SURGERY_ROUTE, HOSPITAL_BILLING_PATIENT, } from '../../../routes/urls';
import { requestModuleHomePath } from './requestNavigation';
import Loader from '../../../components/Loader';

import {
    useLocation
  } from "react-router-dom";
import { connect } from 'react-redux';
import EditServices from './Edit';
import { RequestStatus, RequestType, ServiceType } from './types';
import { RequestTableService } from './RequestTable';
import { fetchProfileInfoAction } from '../../../redux/actions/profileActions';
import RequestSingle from './RequestSingle';
import { TYPE_IMAGE_SURVEY, TYPE_LAB_SURVEY } from '../../../constants';
import SectionHeader from '../../components/SectionHeader';
import { requestTypeToTranslation } from '../../../utils/index.jsx';
import { FUNCTIONALITY } from '../../../constants/types';
import ServiceRecords from './ServiceRecords';
import { withLocalize } from 'react-localize-redux';



export function RequestsService(props){
    let location = useLocation();
    const parameters = useParams();
    return <RequestsServiceComponent requestServiceType={props.requestServiceType} parameters={parameters} {...props}/>
}

export function RequestsServiceComponent(props) {
    const [edit, setEdit] = useState(false);
    const history = useHistory();
    const idRequest = props.parameters.idRequest;
    const functionalitiesWithRequests = [FUNCTIONALITY.REQUESTS, FUNCTIONALITY.SURGERY];
    const dispatch = useDispatch(); 
    const showRequests = useMemo(() => {
        if(!props.investigations.currentInvestigation){
            return false;
        }
        const labOrImageRequests = [ServiceType.IMAGING, ServiceType.LABORATORY].includes(props.requestServiceType) && props.investigations.currentInvestigation.functionalities.includes(FUNCTIONALITY.REQUESTS);
        const surgeryRequests = props.requestServiceType === ServiceType.SURGERY && props.investigations.currentInvestigation.functionalities.includes(FUNCTIONALITY.SURGERY);
        const shoeRequests = props.requestServiceType === ServiceType.SHOE && props.investigations.currentInvestigation.functionalities.includes(FUNCTIONALITY.SHOE_SHOP);
        return labOrImageRequests || surgeryRequests || shoeRequests;
    }, [props.investigations]);


    useEffect(() => {
        
        if(props.investigations.currentInvestigation){
            if(!props.profile.info){
                dispatch(fetchProfileInfoAction(props.investigations.currentInvestigation.uuid));
            }
        }
    }, [ props.investigations]);
    
    function toogleEditLab(){
        //DIsabled, we dont want clients to edit requests
        //setEdit(edit => !edit);
    }

    function createAppointmentFromRequest(requestId){
        const nextUrl = HOSPITAL_SURGERY_CREATE_APPOINTMENT_FROM_REQUEST.replace(":idRequest", requestId);
        history.push(nextUrl);
    }

    function goToBillingPatient(uuidPatient){
        const nextUrl = HOSPITAL_BILLING_PATIENT.replace(":uuidPatient", uuidPatient);
        window.open(nextUrl, '_blank');
    }

    function goToAppointmentFromRequest(uuidAppointment){
        const nextUrl = HOSPITAL_SURGERY_APPOINTMENT.replace(":uuidAppointment", uuidAppointment);
        history.push(nextUrl);
    }

    function accessRequest(request){
        let nextUrl = null;
        
        if(props.requestServiceType === ServiceType.LABORATORY){
            nextUrl = HOSPITAL_LAB_REQUEST.replace(":idRequest", request.id)    
        }
        else if(props.requestServiceType === ServiceType.IMAGING){
            nextUrl = HOSPITAL_IMAGING_REQUEST.replace(":idRequest", request.id)
        }
        else if(props.requestServiceType === ServiceType.SURGERY){
            nextUrl = HOSPITAL_SURGERY_REQUEST.replace(":idRequest", request.id)
        }
        else{
            nextUrl = HOSPITAL_SHOES_REQUEST.replace(":idRequest", request.id)
        }
        if(nextUrl){
            history.push(nextUrl);
        }
        
    }
    function goToHomeTest(serviceType){
        history.push(requestModuleHomePath(serviceType));
    }
    function renderCore(){ 
        if(showRequests){
            if(edit){
                return (
                    <EditServices serviceType={props.requestServiceType} uuidInvestigation={props.investigations.currentInvestigation.uuid} 
                        surveys={props.investigations.currentInvestigation.surveys} />
                );
            }
            else if(idRequest){
                return (
                    <RequestSingle idRequest={idRequest} permissions={props.investigations.currentInvestigation.permissions}
                        requestServiceType={props.requestServiceType}
                        uuidInvestigation={props.investigations.currentInvestigation.uuid} researcher={props.researcher}
                        country={props.investigations.currentInvestigation.country} requestSentCallBack={() => goToHomeTest(props.requestServiceType)}
                        surveys={props.investigations.currentInvestigation.surveys}/>
                )
            }
            else{
                return <RequestTableService searchFor='general.patient' requestServiceType={props.requestServiceType} showActions={true} fillRequest={true} 
                            callBackRequestSelected={(request) => accessRequest(request)}
                            activeLanguageCode={props.activeLanguage.code}
                            createAppointmentFromRequestCallback={(requestId) => createAppointmentFromRequest(requestId)}
                            goToAppointmentFromRequestCallback={(uuidAppointment) => goToAppointmentFromRequest(uuidAppointment)}
                            goToBillingPatientCallback={(uuidPatient) => goToBillingPatient(uuidPatient)}
                            encryptionData={{
                                encryptedKeyUsed : props.investigations.currentInvestigation.encryptedKeyUsed,
                                keyResearcherInvestigation: props.investigations.currentInvestigation.keyResearcherInvestigation,
                                permissions: props.investigations.currentInvestigation.permissions,
                                personalFields: props.investigations.currentInvestigation.personalFields 
                            }}
                            surveys={props.investigations.currentInvestigation.surveys}
                            uuidInvestigation={props.investigations.currentInvestigation.uuid}  />
    
            }
        }
        else{
            return <ServiceRecords key={props.requestServiceType} submissions={props.submissions} patients={props.patients} 
                        investigations={props.investigations} requestType={props.requestServiceType === 0 ? TYPE_LAB_SURVEY : TYPE_IMAGE_SURVEY } />
        }
        
    }
    
    if(!props.investigations.currentInvestigation){
        return <Loader />
    }
    return (
        <React.Fragment>
            <Grid container spacing={3} >
                <Grid item xs={12}>
                    <SectionHeader section={requestTypeToTranslation(props.requestServiceType)} 
                        edit={edit} editCallback={showRequests ? toogleEditLab : null} />
                </Grid>
                <Grid item xs={12}>
                    {
                        renderCore()
                    }     
                </Grid>         
            </Grid>
        </React.Fragment>
    )
}

const mapStateToProps = (state) =>{
    return {
        investigations:state.investigations,
        submissions:state.submissions,
        patients:state.patients,
        profile:state.profile,
    }
}

RequestsService.propTypes = {
    requestServiceType: PropTypes.oneOf(Object.values(ServiceType)).isRequired,
    investigations: PropTypes.shape({
        currentInvestigation: PropTypes.shape({
            uuid: PropTypes.string,
            functionalities: PropTypes.arrayOf(PropTypes.string),
            permissions: PropTypes.object,
            encryptedKeyUsed: PropTypes.bool,
            keyResearcherInvestigation: PropTypes.string,
            personalFields: PropTypes.array,
            surveys: PropTypes.array,
            country: PropTypes.string,
        }),
    }).isRequired,
    submissions: PropTypes.object,
    patients: PropTypes.object,
    profile: PropTypes.shape({
        info: PropTypes.object,
    }),
    researcher: PropTypes.object,
    personalFields: PropTypes.array,
}

export default withLocalize(connect(mapStateToProps, null)(RequestsService))